export default __webpack_public_path__ + "static/media/prt-haze.9ef5fdc5.png";